var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { texts } from './texts';
import { ContextMessage } from './ContextMessage';
import { ContextMessageIcon } from './ContextMessageIcon';
export var ContextSuccessMessage = function (_a) {
    var _b = _a.locale, locale = _b === void 0 ? 'nb' : _b, rest = __rest(_a, ["locale"]);
    var checkIconSmall = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjAiPjxwYXRoIGQ9Im0zOTUtMzcyLjM4NCAyNzAuNTM5LTI2OS41MzhxNy45MjMtNy45MjMgMTcuNjkyLTcuNjE2IDkuNzY5LjMwOCAxOC4wNzYgOC42MTYgOC4zMDggOC4zMDcgOC4zMDggMTcuODg0IDAgOS41NzYtOC4zMDggMTcuODg0bC0yODMgMjgyLjk5OXEtOS44NDYgOS44NDYtMjIuODA3IDkuODQ2LTEyLjk2MSAwLTIyLjgwNy05Ljg0NmwtMTE0LTExMy45OTlxLTcuOTIzLTcuOTIzLTguMzA4LTE3LjY5Mi0uMzg0LTkuNzY5IDcuOTIzLTE4LjA3NiA4LjMwOC04LjMwOCAxNy44ODQtOC4zMDggOS41NzcgMCAxNy44ODQgOC4zMDhMMzk1LTM3Mi4zODRaIi8+PC9zdmc+';
    var checkIconLarge = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iNDAiPjxwYXRoIGQ9Im0zODAuMTAzLTMyOC41NjMgMzU3LjE4LTM1Ny40MzZxNy40OC03LjE4IDE3LjgyOS03LjM3MiAxMC4zNDktLjE5MiAxOC4xNjkgNy40MDcgNy41NjQgNy44NTUgNy41NjQgMTguMTI3IDAgMTAuMjczLTcuNTY0IDE3LjgzN0w0MDIuMDI1LTI3OC43NDRxLTkuMzU4IDkuMzU4LTIxLjkyMiA5LjM1OHQtMjEuOTIzLTkuMzU4TDE4Ni4zMDgtNDUwLjYxNnEtNy40MzUtNy40OC03LjMyLTE3LjgyOS4xMTUtMTAuMzQ5IDcuOTcxLTE4LjE3IDcuODU1LTcuNTY0IDE3Ljk5OS03LjU2NCAxMC4xNDQgMCAxNy45NjUgNy41NjRsMTU3LjE4IDE1OC4wNTJaIi8+PC9zdmc+';
    return (React.createElement(ContextMessage, __assign({}, rest, { locale: locale, messageType: "success", role: "group", "aria-label": texts[locale].success.ariaLabel, icon: React.createElement(ContextMessageIcon, { smallIconUrl: checkIconSmall, largeIconUrl: checkIconLarge }) })));
};
